import { connect } from 'react-redux'
import { selectCurrentStep, selectIsOnAcceptInvitePage } from '../../selectors'
import ProgressMeter from './view'

const select = state => {
  const currentStep = selectCurrentStep(state)
  return {
    step: currentStep,
    steps: 4,
    hide: selectIsOnAcceptInvitePage(state) || !currentStep,
  }
}

export default connect(select)(ProgressMeter)
